import {Navigate} from "react-router-dom";
import {PlatformLoader} from "@flexinet/ui-components";
import {PortalDashboard} from "../components/PortalDashboard";
import {useAuth} from "../../../hooks/useAuth";
import {useVerifiedPermissions} from "@flexinet/auth-components";
import {actionConstants} from "../../../config/rbac/actions";

export const IndexPage = () => {
    const {user} = useAuth();
    const {
        status,
        authorizing,
        allowedActions,
    } = useVerifiedPermissions();

    if (!user || authorizing) {
        return <PlatformLoader message="Loading dashboard...Please wait!"/>;
    }

    // Interim until FNP-1749. A failed check is not a DENY: redirecting to /
    // would bounce straight back here, because the public home page sends a
    // signed-in user to /dashboard. Throwing hands it to the route's existing
    // errorElement (ApplicationErrorPage), which shows this message. FNP-1728.
    if (status === 'failed') {
        throw new Error("We couldn't check your permissions. Reload the page to try again.");
    }

    // Hiding the navbar entry is not access control: the menu gates on
    // GetDashboard, so the page must make the same decision for anyone who
    // types the URL. FNP-1410.
    if (!allowedActions.includes(actionConstants.GET_DASHBOARD)) {
        return <Navigate to="/"/>;
    }

    return <PortalDashboard/>;
};
